import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import {
  BasicSelect
} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'changehub',
  components: {
    Paginate,
    BasicSelect,
    VueElementLoading,
    Multiselect
  },
  data: function() {
    return {
      hubList: [],
      hubid: '',
      cHubid: '',
      hubObjData: {
        value: "",
        text: ""
      },
      validateFlag: false,
      userid: '',
      isLoading: false,
      useremail: '',
      hubname: '',
      currenthubid: ''
    }
  },

  created: function() {},
  computed: {},

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail[0].email;
    this.userid = userdetail[0].userid;
    this.currenthubid = userdetail[0].HubId[0];
    this.getHubList();
  },
  methods: {
    selectedHub(hubData) {
      this.hubObjData = hubData;
      this.hubid = this.hubObjData.value;
      this.hubname = this.hubObjData.text;
    },
    async authApi() {
      let auth = `Bearer ${window.localStorage.getItem('access_token')}`;
      this.isLoading = true
      await axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'userapp/auth',
          'data': this.input,
          headers: {
            'Authorization': auth
          }
        })
        .then(response => {
          this.isLoading = false
          if (response.data.ResultCode == 100) {
            if (response.data.ResponseData.accessurls.length > 0) {
              var permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.ResponseData.accessurls), "Key");
              window.localStorage.setItem('permissiondata', permissionEncrypt);
            } 
          } else {
            this.$alertify.error(response.data.ReturnMessage);
          }
        }, error => {
          this.isLoading = false
          this.$alertify.error('error in api')
        })
    },
    // getHubList() {
    //   this.isLoading = true;
    //   this.input = ({
    //     userid: this.userid,
    //     appkey: "$Hub&&$Ops@",
    //   })
    //   axios({
    //     method: 'POST',
    //     'url': apiUrl.api_url + 'users/GetHubAcessOfUser',
    //     'data': this.input,
    //     headers: {
    //       'Authorization': 'Bearer vKyXQBGQCK',
    //     }
    //   })
    //     .then(result => {
    //       this.isLoading = false;
    //         var hubList = result.data.data.hubaccess
    //         for (var i = 0; i < hubList.length; i++) {
    //           this.hubList.push({
    //             value: hubList[i].HubID,
    //             text: hubList[i].HubName + ' (' + hubList[i].HubID + ')',
    //           })
    //         }
    //     }, error => {
    //       this.isLoading = false;
    //       console.error(error)
    //     })
    // },
    getHubList() {
      this.isLoading = true;
      this.input = ({
        userid: this.userid,
        currenthubid: this.currenthubid
      })
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getAllocatedHubsForUser',
          'data': this.input,
          'headers': {
            'authorization': (apiUrl.isKavachLogin) ? `Bearer ${window.localStorage.getItem('access_token')}` : 'authkey xB84JJ89Hd25',
          }
        })
        .then(async result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            var hubList = result.data.ResponseData
            for (var i = 0; i < hubList.length; i++) {
              this.hubList.push({
                value: hubList[i].HubID,
                text: hubList[i].HubName + ' (' + hubList[i].HubID + ')',
              })
            }
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },

    saveUpdateCurrentHubId() {
      this.$validator.validateAll().then((formResult) => {
        if (formResult == false) {
          return false;
        } else {
          this.isLoading = true;

          let auth = "authkey xB84JJ89Hd25";
          let url = apiUrl.api_url_hubops + 'updateCurrentHubInUMS';

          this.input = ({
            userid: this.userid,
            currentHub: this.hubid,
          })

          if(apiUrl.isKavachLogin){
            auth = `Bearer ${window.localStorage.getItem('access_token')}`;
            url = apiUrl.api_url_hubops + 'userapp/updateCurrentHub';

            this.input = ({
              userid: parseInt(this.userid),
              currentHub: this.hubid.toString(),
            })
          }

          axios({
              method: 'POST',
              'url': url,
              'data': this.input,
              headers: {
                'Authorization': auth,
              }
            })
            .then(async result => {
              this.isLoading = false;
            
              if (result.data.code == 200) {
                if(apiUrl.isKavachLogin){
                  await this.authApi(); 
                 }
                var userdetailEncrypt = window.localStorage.getItem('userdetail');
                var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                var userdetail = JSON.parse(plaintext);
                var temp = [];
                temp[0] = this.hubid;
                userdetail[0].HubId = temp;
                var userdetailEncrypt = CryptoJS.AES.encrypt(JSON.stringify(userdetail), "Key");
                window.localStorage.setItem('userdetail', userdetailEncrypt);
                this.$alertify.success(result.data.message);
                this.$router.push('/dashboard');
                $("#crnt_hub").html(this.hubname);
                window.location.reload()
              } else {
                this.$alertify.error(result.data.message)
              }
              this.resetForm();
            }, error => {
              console.error(error)
            })
        }
      })

    },

    //to reset search form
    resetForm() {
      // document.getElementById("hubid").value = "";
      this.hubObjData = {
        value: "",
        text: ""
      };
      this.hubid = '';
      this.cHubid = '';
      this.hubname = '';
      //console.log(this.modeObjData);
      this.$validator.reset();

    },

    //validate all form fields on onsubmit()
    onSubmit: function(formname) {
      this.$validator.validateAll().then((formResult) => {
          if (formResult == false) {
            this.validateFlag = false
          } else {
            this.validateFlag = true;
            console.log('form is valid')
          }
        })
        .catch(() => {
          console.log('errors exist')
        });
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/changehub/changehub_component.js